import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'emDash',
})
export class EmDashPipe implements PipeTransform {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transform(value: any): any {
    if (value === null || value === undefined || value === '') {
      return '—'
    }
    return value
  }
}
